import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import Route from 'route-parser'
import url from 'libraries/front-end-core/core/url'
import { MENU_ITEMS } from 'constants/menu'
import { URL_LOGOUT, URL_IDP_LOGIN, URL_DOC_DRAFTER_SAVED_DOCUMENTS } from 'constants/urls'
import { URL_TEAMS, URL_SUPPORT } from 'constants/links'
import { USER_ADMIN, UTILS } from 'constants/controllers'
import { USER_ADMIN_ENABLED } from 'constants/feature-flags'
import preLogout from 'helpers/preLogout'
import selectIsDocDrafter from 'redux/selectors/selectIsDocDrafter'
import selectIsFirmAdmin from 'redux/selectors/selectIsFirmAdmin'
import Dropdown from 'components/Dropdown'

const SavedDocsRoute = new Route(URL_DOC_DRAFTER_SAVED_DOCUMENTS)

const getAccountDropdownOptions = ({ isFirmAdmin, isDocDrafter, aol, flavour, isLogged }) => {
  const menuItems = [...MENU_ITEMS]
    .reverse()
    .filter(item => item.target !== USER_ADMIN || (isFirmAdmin && USER_ADMIN_ENABLED))
    .reduce((acc, item) => {
      if (item.position === 'side-bottom') {
        return [...acc, item]
      }
      if (item.type === 'group') {
        return [...acc, ...item.items]
      }
      return acc
    }, [])

  const items = menuItems

  const options = items.map(item => ({
    label: item.title,
    href: item.url || item.target,
    icon: item.icon,
    external: item.external
  }))

  if (isDocDrafter) {
    options.push({
      label: 'Saved Documents',
      href: SavedDocsRoute.reverse({ aol }),
      external: true
    })
  }
  if (process.env.NODE_ENV === 'development') {
    options.push({
      label: 'Developer utils',
      href: url(UTILS, { flavour })
    })
  }
  if (isLogged) {
    options.push({
      label: 'Team',
      href: URL_TEAMS,
      external: true
    })
    options.push({
      label: 'Support',
      href: URL_SUPPORT,
      external: true
    })
  }
  options.push({
    label: isLogged ? 'Log out' : 'Log in',
    href: isLogged ? URL_LOGOUT : URL_IDP_LOGIN,
    isLogout: true
  })

  return options
}

const AccountMenu = ({ flavour, isLogged, isExternalAuth, aol }) => {
  const isDocDrafter = useSelector(selectIsDocDrafter)
  const isFirmAdmin = useSelector(selectIsFirmAdmin)

  const dropdownOptions = getAccountDropdownOptions({
    isFirmAdmin,
    isDocDrafter,
    aol,
    flavour,
    isLogged
  })

  const handleSelect = (href, e) => {
    if (href === URL_LOGOUT) {
      preLogout()
    }
  }

  return (
    <Dropdown
      label='My Account'
      options={dropdownOptions.map(option =>
        option.external
          ? { ...option, target: '_blank', rel: 'noopener noreferrer' }
          : option
      )}
      handleOnSelect={handleSelect}
      testId='account-menu'
      align='end'
      classes={{
        button: 'black bg-transparent hover-slate-grey active-light-slate-grey',
        chevron: ({ open, hover }) => classNames(
          'black',
          {
            'slate-grey': hover,
            'light-slate-grey': open
          }
        ),
        menu: 'bg-white z5',
        option: ({ focus }) => classNames(
          'black no-underline',
          {
            'bg-casper-white': focus,
            'bg-white': !focus
          }
        )
      }}
    />
  )
}

export default AccountMenu
